import { Routes, Route } from 'react-router-dom';
import Header from '../widjets/header/Header';
import './App.scss';
import HomePage from '../pages/home/HomePage';
import ProfilePage from '../pages/profile/ProfilePage';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import LoginPage from '../pages/login/LoginPage';
import { useEffect, useState } from 'react';
import { preloadImages, preloadJSON, preloadPublicImages } from '../funcs/preload';
import { IMAGES } from '../assets/media/images';
import { STICKERS } from '../assets/media/stickers';
import Navbar from '../widjets/navbar/Navbar';
import NotFound from '../pages/notFound/NotFound';
import CardPage from '../pages/card/CardPage';
import Loader from '../components/loading/Loader';

const tg = window.Telegram.WebApp;

function App() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    tg.ready();
    tg.expand();
    tg.disableVerticalSwipes();

    Promise.all([
      preloadImages(Object.values(IMAGES)),
      preloadJSON(Object.values(STICKERS)),
      preloadPublicImages(),
    ]).then(() => setTimeout(() => setIsReady(true), 1000));
  }, []);

  if (!isReady) return <Loader />;

  return (
    <div className='app'>
      <div className='wrapper'>
        <Header />
        <Navbar />
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/menu" element={<NotFound />} />
            <Route path="/arena" element={<NotFound />} />
            <Route path="/card" element={<CardPage />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
